import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ActionsData, DataRest, IdDataRest, SceneriesData, SceneryData, SchedulesData, StepsData } from '../model/api/data-rest';
import { Scenery } from '../model/scenery';
import { environment } from 'src/environments/environment';
import { resources } from './api';
import { SceneryStep } from '../model/scenery-step';
import { SceneryAction } from '../model/scenery-action';
import { Schedule } from '../model/schedule';

@Injectable({
    providedIn: 'root'
})
export class SceneryService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getSceneries(userId?: number, siteId?: number): Observable<SceneriesData> {
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        if (siteId) {
            return this.http.get<SceneriesData>(
                `${environment.apiUrl}${resources.get('sceneries')}${resources.get('by')}${resources.get('site')}/${siteId}`,
                { params }
            );
        }
        return this.http.get<SceneriesData>(`${environment.apiUrl}${resources.get('sceneries')}`, { params });
    }

    getScenery(id: number): Observable<SceneryData> {
        return this.http.get<SceneryData>(`${environment.apiUrl}${resources.get('sceneries')}/${id}`);
    }

    addScenery(scenery: Scenery): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('sceneries')}`, scenery);
    }

    editScenery(scenery: Scenery): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('sceneries')}/${scenery.Id}`, scenery);
    }

    executeScenery(sceneryId: number): Observable<DataRest> {
        return this.http.get<DataRest>(`${environment.apiUrl}${resources.get('schedule')}${resources.get('scenery')}/${sceneryId}`);
    }

    deleteScenery(id: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('sceneries')}/${id}`);
    }

    addStep(step: SceneryStep): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('step')}`, step);
    }

    editStep(step: SceneryStep): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('step')}/${step.Id}`, step);
    }

    addAction(action: SceneryAction): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('action')}`, action);
    }

    editAction(action: SceneryAction): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('action')}/${action.Id}`, action);
    }

    getSteps(sceneryId: number): Observable<StepsData> {
        let params = new HttpParams();
        if (sceneryId) {
            params = params.set('sceneryId', sceneryId.toString());
        }
        return this.http.get<StepsData>(`${environment.apiUrl}${resources.get('step')}`, { params });
    }

    reorderSteps(steps: SceneryStep[]): Observable<DataRest> {
        return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('step')}${resources.get('updateOrder')}`, steps);
    }

    deleteStep(stepId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('step')}/${stepId}`);
    }

    getActions(stepId?: number): Observable<ActionsData> {
        let params = new HttpParams();
        if (stepId) {
            params = params.set('stepId', stepId.toString());
        }
        return this.http.get<ActionsData>(`${environment.apiUrl}${resources.get('action')}`, { params });
    }

    getSchedules(userId?: number, siteId?: number): Observable<SchedulesData> {
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        if (siteId) {
            return this.http.get<SchedulesData>(
                `${environment.apiUrl}${resources.get('schedules')}${resources.get('by')}${resources.get('site')}/${siteId}`,
                { params }
            );
        }
        return this.http.get<SchedulesData>(`${environment.apiUrl}${resources.get('schedules')}`, { params });
    }

    deleteSchedule(scheduleId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('schedules')}/${scheduleId}`);
    }

    updateSchedule(schedule: Schedule): Observable<DataRest> {
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('schedules')}/${schedule.Id}`, schedule);
    }
}

